function logError(...params){
    if(!localStorage['logApp']) return;
    console.log(...params);
}

export { logError }